import(/* webpackMode: "eager" */ "/app/frontend-next/src/app/_ui/components/core/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoStatic"] */ "/app/frontend-next/src/app/_ui/components/core/Logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CCPAOptOut"] */ "/app/frontend-next/src/app/_ui/components/navigation/footer/CCPAOptOut.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieSettings"] */ "/app/frontend-next/src/app/_ui/components/navigation/footer/CookieSettings.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSelectorTrigger","LanguageSelector"] */ "/app/frontend-next/src/app/_ui/components/navigation/footer/LanguageSelector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageFooterProvider"] */ "/app/frontend-next/src/app/_ui/components/navigation/footer/PageFooterContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.8.3_@swc+helpers@0.5.19_next@16.2.2_@babel+core@7.29.0_@opentelemetry+api@1_622da044ce9ee44dbbbc2340f85851cf/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
